if (!customElements.get('recipient-product-tabs')) {
  class RecipientProductTabs extends HTMLElement {
    connectedCallback() {
      this.eventController?.abort();
      this.eventController = new AbortController();
      const { signal } = this.eventController;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.selectTab(index), { signal });
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, index), { signal });
      });

      this.setupSliders();
    }

    disconnectedCallback() {
      this.eventController?.abort();
      this.querySelectorAll('.pra-v2-recipient-products__track').forEach((track) => track.classList.remove('is-dragging'));
    }

    selectTab(index, moveFocus = false) {
      const selectedTab = this.tabs[index];
      if (!selectedTab) return;

      this.tabs.forEach((tab, tabIndex) => {
        const selected = tabIndex === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== selectedTab.getAttribute('aria-controls');
      });

      const activeTrack = this.querySelector(`#${CSS.escape(selectedTab.getAttribute('aria-controls'))} .pra-v2-recipient-products__track`);
      if (activeTrack) activeTrack.scrollLeft = 0;
      if (moveFocus) selectedTab.focus();
    }

    handleKeydown(event, index) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();

      let nextIndex = index;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      this.selectTab(nextIndex, true);
    }

    setupSliders() {
      const { signal } = this.eventController;
      this.querySelectorAll('.pra-v2-recipient-products__track').forEach((track) => {
        let pointerId = null;
        let startX = 0;
        let startScrollLeft = 0;
        let dragged = false;

        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'touch') return;
          pointerId = event.pointerId;
          startX = event.clientX;
          startScrollLeft = track.scrollLeft;
          dragged = false;
        }, { signal });

        track.addEventListener('pointermove', (event) => {
          if (event.pointerId !== pointerId) return;
          const distance = event.clientX - startX;
          if (!dragged && Math.abs(distance) > 4) {
            dragged = true;
            track.setPointerCapture(pointerId);
            track.classList.add('is-dragging');
          }
          if (!dragged) return;
          track.scrollLeft = startScrollLeft - distance;
        }, { signal });

        const finishDrag = (event) => {
          if (event.pointerId !== pointerId) return;
          if (track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId);
          pointerId = null;
          track.classList.remove('is-dragging');
        };

        track.addEventListener('pointerup', finishDrag, { signal });
        track.addEventListener('pointercancel', finishDrag, { signal });
        track.addEventListener('lostpointercapture', () => {
          pointerId = null;
          track.classList.remove('is-dragging');
        }, { signal });
        track.addEventListener('click', (event) => {
          if (!dragged) return;
          event.preventDefault();
          event.stopPropagation();
          dragged = false;
        }, { capture: true, signal });
      });
    }
  }

  customElements.define('recipient-product-tabs', RecipientProductTabs);
}
